import { createIcon } from '@chakra-ui/icons';

export const TrackAssessment = createIcon({
  displayName: 'TrackAssessment',
  viewBox: '0 0 20 20',
  path: [
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <rect width="20" height="20" rx="10" fill="#FDE9C8" />
      <g clipPath="url(#clip0_308_4093)">
        <path
          d="M8.33301 7.9163H7.91801V7.5013V5.83464C7.91801 5.83419 7.91783 5.83377 7.91752 5.83346C7.91721 5.83314 7.91678 5.83297 7.91634 5.83297H5.83301C5.83257 5.83297 5.83214 5.83314 5.83183 5.83346C5.83152 5.83377 5.83134 5.83419 5.83134 5.83464V14.168C5.83134 14.1684 5.83152 14.1688 5.83183 14.1691C5.83214 14.1695 5.83256 14.1696 5.83301 14.1696H14.1663C14.1668 14.1696 14.1672 14.1695 14.1675 14.1691C14.1678 14.1688 14.168 14.1684 14.168 14.168V12.0846C14.168 12.0842 14.1678 12.0838 14.1675 12.0835C14.1672 12.0831 14.1668 12.083 14.1663 12.083H12.4997H12.0847V11.668V10.0013C12.0847 10.0009 12.0845 10.0004 12.0842 10.0001C12.0839 9.99981 12.0834 9.99964 12.083 9.99964H10.4163H10.0013V9.58464V7.91797C10.0013 7.91753 10.0012 7.9171 10.0009 7.91679C10.0005 7.91648 10.0001 7.9163 9.99967 7.9163H8.33301Z"
          stroke="#977334"
          strokeWidth="0.83"
        />
      </g>
      <defs>
        <clipPath id="clip0_308_4093">
          <rect width="10" height="10" fill="white" transform="matrix(-1 0 0 1 15 5)" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
